import OSS from "ali-oss";
import { OSSFileApi } from "@newview/netfsserver-api";
import {FileinforApi} from "@newview/system-api";

const datasetFileApi: OSSFileApi = new OSSFileApi();
const fileinforApi: FileinforApi = new FileinforApi();

/**
 * 获取aliOSS客户端
 * @returns
 */
 export const getOSSClient = async (config={
    region:"oss-cn-hangzhou",
    bucket:"trailroom",
 }) => {
    /** 过期时间 */
    let expiration = window["globleOssExpiration"]?window["globleOssExpiration"]:0
    /** 当前时间 */
    let nowtime = new Date().getTime()
    //未New过OSS对象 或 临时授权过期
    if(!window["globleOssObj"] || nowtime>=expiration){
        const aliSTS = (await fileinforApi.getAliOSS()).data;
        window["globleOssExpiration"] = new Date(aliSTS.credentials.expiration).getTime()
        window["globleOssObj"] = new OSS({
            // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
            region: config.region,
            accessKeyId: aliSTS.credentials.accessKeyId,
            accessKeySecret: aliSTS.credentials.accessKeySecret,
            stsToken: aliSTS.credentials.securityToken,
            // 填写Bucket名称。
            bucket: config.bucket,
            // 刷新临时访问凭证。
            refreshSTSToken: async () => {
                const aliSTS = (await fileinforApi.getAliOSS()).data;
                return {
                    accessKeyId: aliSTS.credentials.accessKeyId,
                    accessKeySecret: aliSTS.credentials.accessKeySecret,
                    stsToken: aliSTS.credentials.securityToken
                }
            }
        });
    }  
    return window["globleOssObj"];
}

/**
 * 获取文件安全路径
 * @param fileName
 * @returns
 */
export const getSignatureUrl = async (fileName,config:{region:string,bucket:string}) => {
    const client = await getOSSClient(config);
    return await client.signatureUrl(fileName);
};


/**
 * 获取aliOSS客户端
 * @returns
 */
export const getOSSClientNet = async () => {
    const aliSTS = (await datasetFileApi.GetAliSTS()).result;
    const client = new OSS({
        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
        region: 'oss-cn-beijing',
        accessKeyId: aliSTS.Credentials.AccessKeyId,
        accessKeySecret: aliSTS.Credentials.AccessKeySecret,
        stsToken: aliSTS.Credentials.SecurityToken,
        // 填写Bucket名称。
        bucket: 'nvplanfromoss',
        // 刷新临时访问凭证。
        refreshSTSToken: async () => {
            const aliSTS = (await datasetFileApi.GetAliSTS()).result;
            return {
                accessKeyId: aliSTS.Credentials.AccessKeyId,
                accessKeySecret: aliSTS.Credentials.AccessKeySecret,
                stsToken: aliSTS.Credentials.SecurityToken,
            }
        }
    });

    return client;
}

/**
 * 获取文件安全路径
 * @param fileName
 * @returns
 */
export const getSignatureUrlNet = async (fileName) => {
    const client = await getOSSClient();
    return await client.signatureUrl(fileName);
};
